import { render } from "./SalidasProductos.vue?vue&type=template&id=1f565e10&scoped=true"
import script from "./SalidasProductos.vue?vue&type=script&lang=js"
export * from "./SalidasProductos.vue?vue&type=script&lang=js"

import "./SalidasProductos.vue?vue&type=style&index=0&id=1f565e10&lang=css"
import "./SalidasProductos.vue?vue&type=style&index=1&id=1f565e10&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f565e10"]])

export default __exports__